<template>
  <v-container>
    <row-header action="back" :msg="msgRowHeader"></row-header>

    <v-row dense>
      <v-col>
        <v-form
            ref="form"
            v-model="valid"
        >
          <v-card>
            <product-form-component
                :product_model="product_model"
                :cat_prod="cat_prod"
                :bank_prod="bank_prod"
                update="0"
            />
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  :disabled="!valid"
                  color="success"
                  @click="saveData"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>

    <v-overlay
        :absolute="absolute"
        :value="overlay"
    >
      <v-card color="white">
        <v-card-text>
          <overlay-img></overlay-img>
        </v-card-text>
      </v-card>
    </v-overlay>

  </v-container>
</template>

<script>
import RowHeader from "../../../components/content/RowHeader";
import OverlayImg from "../../../components/content/OverlayImg";
import ProductFormComponent from '../../../components/page/products/ProductFormComponent';
import { ProductData } from '../../../store/services/ProductModel';
import { PostRequest, GetRequest } from "../../../store/services/users";

export default {
  components: {
    RowHeader,
    OverlayImg,
    ProductFormComponent,
  },
  data:() => ({
    msgRowHeader: {newUser: 'Back', newMsg: 'Create Product'},
    valid: true,
    absolute: false,
    overlay: false,
    product_model: new ProductData(),
    cat_prod: [],
    bank_prod: [],
  }),
  async mounted() {
    console.log('product new page');
    if (this.$store.getters.isLoggedIn && this.$store.getters.currentUser.role.level === 1) {
      this.cat_prod = await this.getCatData();
      this.bank_prod = await this.getBankData();
    }
  },
  methods: {
    async getCatData() {
      await this.$store.dispatch('req_data');
      this.overlay = await this.$store.getters.isLoading;
      try{
        let response = await GetRequest('categories');
        await this.$store.dispatch('req_success');
        this.overlay = await this.$store.getters.isLoading;
        return response.data;
      }catch(err){
        await this.$store.dispatch('req_failed');
        this.overlay = await this.$store.getters.isLoading;
        alert('failed to get data : ' + err.message);
        return [];
      }
    },
    async getBankData() {
      await this.$store.dispatch('req_data');
      this.overlay = await this.$store.getters.isLoading;
      try{
        let response = await GetRequest('banks');
        await this.$store.dispatch('req_success');
        this.overlay = await this.$store.getters.isLoading;
        return response.data;
      }catch(err){
        await this.$store.dispatch('req_failed');
        this.overlay = await this.$store.getters.isLoading;
        alert('failed to get data : ' + err.message);
        return [];
      }
    },
    async saveData() {
      delete this.product_model.category.__v;
      delete this.product_model.provider_prod_code.__v;
      this.product_model.price = Number(this.product_model.price);
      await this.$store.dispatch('req_data')
      this.overlay = this.$store.getters.isLoading;
      try {
        await PostRequest('products', this.product_model);
        this.overlay = this.$store.getters.isLoading;
        await this.$store.dispatch('req_success');
        this.overlay = this.$store.getters.isLoading;
        alert('Create data success');
        await this.$router.push({name: 'ProductList'});
      } catch (e) {
        await this.$store.dispatch('req_failed');
        this.overlay = this.$store.getters.isLoading;
        alert('Create data failed ' + e.message);
      }
    }
  }
}
</script>

<style scoped>

</style>
